// DraftVoice brand assets & constants
// Final official logos provided by the founder — do not regenerate.
export const LOGO_COLOR = "https://customer-assets.emergentagent.com/job_84443a95-42ac-4e4b-82fc-446c5b845f01/artifacts/vqlcg6xd_Draft%20Voice%20Logo.png";
export const LOGO_WORDMARK = "https://customer-assets.emergentagent.com/job_draftnow-voice/artifacts/qwuogkos_Draft%20Voice.png";
export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_84443a95-42ac-4e4b-82fc-446c5b845f01/artifacts/2w7hbigp_Draft%20Voice%20White%20Logo.png";

export const HERO_WAVE = "https://static.prod-images.emergentagent.com/jobs/84443a95-42ac-4e4b-82fc-446c5b845f01/images/0fb0d8cff8751b83576add109adb75726453396d1e64a536b60dc077d2fbb6b3.png";
export const FEATURE_DICTATION = "https://static.prod-images.emergentagent.com/jobs/84443a95-42ac-4e4b-82fc-446c5b845f01/images/d73270fffb8fb5a860a019b7aab5906e36d82666a0676c36f3b960324138cdfb.png";
export const FEATURE_TRANSLATION = "https://static.prod-images.emergentagent.com/jobs/84443a95-42ac-4e4b-82fc-446c5b845f01/images/ffb204dbf59d050f4b3d0e9bd6ecbc01c3f24a3c5034c785e930b58d2ce26bdf.png";

export const OUTPUT_MODES = [
  { id: "raw", label: "Raw Text", icon: "Mic", desc: "Exactly what you said — preserves the original language" },
  { id: "smart_english", label: "Smart English", icon: "Languages", desc: "Default — Telugu/Hindi/Mixed → natural English" },
  { id: "clean", label: "Grammar Fix", icon: "Sparkles", desc: "Fix grammar and remove fillers — same language" },
  { id: "email", label: "Email", icon: "Mail", desc: "Professional email with subject" },
  { id: "whatsapp", label: "WhatsApp", icon: "MessageCircle", desc: "Short friendly reply" },
  { id: "prompt", label: "AI Prompt", icon: "Wand2", desc: "Ready for ChatGPT / Claude" },
  { id: "meeting_note", label: "Meeting Notes", icon: "Users", desc: "Summary · Decisions · Action items" },
];

export const LANGUAGES = [
  { id: "auto", label: "Auto detect", flag: "✨" },
  { id: "en", label: "English", flag: "🇬🇧" },
  { id: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { id: "te", label: "తెలుగు", flag: "🇮🇳" },
  { id: "mixed", label: "Mixed / Hinglish", flag: "🌏" },
];

export const TRANSFORMS = [
  { id: "polish", label: "Polish" },
  { id: "professional", label: "Professional" },
  { id: "shorten", label: "Shorten" },
  { id: "expand", label: "Expand" },
  { id: "translate_en", label: "Translate to English" },
  { id: "to_prompt", label: "Convert to Prompt" },
];
